import React from "react";
import { FormattedMessage } from "react-intl";
import OptionSelectComponent from "../option/OptionSelectComponent";
import EventFormError from "../errors/EventFormError";

class EventRegistrationTextFormComponent {
    static fields(state, form) {
        let fields = [{
            type: "col",
            md: 12,
            fields: [
                {
                    title: "CMS.Event.registration.Content.Form.event",
                    type: "select",
                    name: 'event',
                    options: state.events.map(item => {
                        return { value: item.id, label: item.contents[0].title };
                    }),
                    onChange: (form.handleEventChange),
                    customFeedback: EventFormError,
                    formErrorName: "event"
                }
            ]
        }];

        if (state.periods.length > 0 && state.model.event) {
            fields.push({
                type: "col",
                md: 12,
                fields: [
                    {
                        title: "CMS.Event.registration.Content.Form.period",
                        type: "select",
                        name: 'period',
                        options: state.periods.map(item => {
                            return { value: item.id, label: item.contents[0].title };
                        }),
                        customFeedback: EventFormError,
                        formErrorName: 'period'
                    }
                ],
                custom: EventRegistrationFullWarning,
                customProps: { periods: state.periods }
            });
        }


        fields.push({
            type: "col",
            md: 12,
            fields: [
                {
                    title: "CMS.Event.registration.Content.Form.client",
                    type: "select",
                    name: 'client',
                    options: state.clients.map(item => {
                        return { value: item.id, label: item.fullname() };
                    }),
                    onChange: (form.handleClientChange),
                    customFeedback: EventFormError,
                    formErrorName: 'client'
                }
            ]
        });

        if (state.settings.use_attendees && state.attendees.length > 0 && state.model.client) {
            fields.push({
                type: "col",
                md: 12,
                fields: [
                    {
                        title: "CMS.Event.registration.Content.Form.attendee",
                        type: "select",
                        name: 'attendee',
                        options: state.attendees.map(item => {
                            return { value: item.hash, label: item.fullname() };
                        }),
                        customFeedback: EventFormError,
                        formErrorName: "attendee"
                    }
                ]
            }, {
                type: "col",
                md: 12,
                fields: [
                    {
                        title: "CMS.Event.registration.Content.Form.free",
                        type: "switch",
                        name: 'free',
                        customFeedback: EventFormError,
                        formErrorName: "free"
                    }
                ]
            });
        }

        if (state.optionGroups.length > 0) {
            fields.push({
                type: "col",
                md: 12,
                fields: [],
                custom: EventRegistrationOptionsField,
                customProps: { groups: state.optionGroups, periods: state.periods }
            });
        }

        return [{ type: "row", children: fields }];
    }

    static fields_edit(state, form) {
        let fields = [{
            type: "col",
            md: 12,
            fields: [
                {
                    title: "CMS.Event.registration.Content.Form.event",
                    type: "select",
                    name: 'event',
                    options: state.events.map(item => {
                        return { value: item.id, label: item.title };
                    }),
                    customFeedback: EventFormError,
                    formErrorName: "event"
                }
            ]
        }];

        /*if (state.settings.use_attendees && state.attendees.length > 0) {
            fields.push({
                type: "col",
                md: 12,
                fields: [
                    {
                        title: "CMS.Event.registration.Content.Form.attendee",
                        type: "select",
                        name: 'attendee',
                        options: state.attendees.map(item => {
                            return { value: item.id, label: item.fullname() };
                        }),
                        customFeedback: EventFormError,
                        formErrorName: "attendee"
                    }
                ]
            });
        }*/

        return [{ type: "row", children: fields }];
    }
}

/**
 * Warn when the selected period is fully booked (the console can still register)
 */
class EventRegistrationFullWarning extends React.Component {
    render() {
        const period = this.props.periods.filter(item => item.id === this.props.values.period)[0];
        if (!period || !period.isFull()) return null;

        return (
            <FormattedMessage id="CMS.Event.registration.Content.Form.period.full" values={{ maximum: period.maximum_participants }}>
                {value => <p className="input-info text-warning">{value}</p>}
            </FormattedMessage>
        );
    }
}

/**
 * Bridges the formik values of the registration form with the option selection
 */
class EventRegistrationOptionsField extends React.Component {
    render() {
        const { values, handleChange, groups, periods } = this.props;
        const period = periods.filter(item => item.id === values.period)[0] || null;

        return (
            <OptionSelectComponent
                groups={groups}
                value={values.options || []}
                period={period}
                free={!!values.free}
                basePrice={period ? parseFloat(String(period.price).replace(/,/g, '.')) || 0 : null}
                onChange={selection => handleChange({ target: { name: 'options', value: selection } })}
            />
        );
    }
}

export default EventRegistrationTextFormComponent;